export const SFPalette = {
  shuffleColor: "#A19BFD",
  shuffleColor2: "#1398FE",
  shuffleColor3: "#0BC1E4",
  shuffleColor4: "#B800FF",
  lightGrey1: "#DFDFDF",
  lightGrey2: "#C1C1C1",
  lightGrey3: "#FAFAFA",
  grey1: "#A5A5A5",
  grey2: "#8B8B8B",
  grey3: "#6F6F6F",
  grey4: "#555555",
  grey5: "#3D3D3D",
  darkGrey1: "#3D3D3D",
  darkGrey2: "#242424",
  black: "#000000",
}